import { Component, OnDestroy} from '@angular/core';
import { ActivatedRoute, Params, ParamMap } from "@angular/router";
import { ForSigningModelService } from '../for-signing.model.service';
import { NavigationStateService } from '../../navigation/navigation.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { environment } from '../../../../../environments/environment';
import { ForSigningHttpService } from '../../../../services/forsigning/forsigning.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { ForSigningHttpUtil } from '../for-signing.util';

@Component({
  moduleId: module.id,
  templateUrl: 'forsigning.single.index.component.html',
  providers: []
})

export class ForSigningSingleIndexComponent implements OnDestroy  {

  model: any = {};
  errorMessage: string;
  mobileInfoBoxStatus: boolean = false;
  settings: any = {};

  constructor(
    private route: ActivatedRoute,
    private contractModelService: ForSigningModelService,
    private navigationStateService: NavigationStateService,
    private authUtil: AuthUtil,) {
      this.settings = environment;
  }

  ngOnInit() {
    this.navigationStateService.triggerNavigationStatus({status: false});
    let data = this.route.snapshot.data['data'];

    if(this.authUtil.isError(data.json())) {
          this.authUtil.checkErrorResponse(data.json());
          this.contractModelService.setData(false);
    } else {
      this.model = data.json().response;
      this.contractModelService.setData(this.model);
    }
  }

  toggleMobileInfoBox($event) {
    $event.preventDefault();
    this.mobileInfoBoxStatus = !this.mobileInfoBoxStatus;
  }

  ngOnDestroy() {
    this.navigationStateService.triggerNavigationStatus({status: true});
    this.contractModelService.removeData();
  }

  downloadAttach($event) {
    $event.preventDefault();
    this.errorMessage = '';

    const data = {
      securityToken: StorageUtil.getToken(),
    };
    
    const requestParams = ForSigningHttpUtil.prepareParamsContracts(data);
    window.open(ForSigningHttpService.ALL_CONTRACTS_URL + '/' + this.model.epId + '/attach' + '?' + requestParams.toString(), '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/single-index/forsigning.single.index.component.ts